import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _typeof from "@babel/runtime/helpers/esm/typeof";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable no-unused-vars */

/* eslint-disable new-cap */
import miloRequest from '../../common/network';
import cookie from '../../common/cookie';
import { isFunction } from '../../common/base';
import wechat from '../jsBridge/wx';
import ATM from '../../util/atm';
import { getGameId } from '../login/common';
var wxclient = {
  apiurl: "".concat(location.protocol, "//apps.game.qq.com/ams/wx/getSignature.php"),
  jsliburl: "".concat(location.protocol, "//res.wx.qq.com/open/js/jweixin-1.6.0.js"),
  // 新的jssdk
  sAppId: '',
  defopt: {
    debug: false,
    jsApiList: ['checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo', 'hideMenuItems', 'showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'translateVoice', 'startRecord', 'stopRecord', 'onRecordEnd', 'playVoice', 'pauseVoice', 'stopVoice', 'uploadVoice', 'downloadVoice', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'getNetworkType', 'openLocation', 'getLocation', 'hideOptionMenu', 'showOptionMenu', 'closeWindow', 'scanQRCode', 'chooseWXPay', 'openProductSpecificView', 'addCard', 'chooseCard', 'openCard'],
    autoConfig: true
  },
  // 微信客户端初始化
  init: function init(opt, callback) {
    // 兼容没有opt的情况
    if (_typeof(opt) === 'object') {
      this.defopt = _objectSpread(_objectSpread({}, this.defopt), opt);

      if (typeof callback === 'function') {
        this.defopt.callback = callback;
      }
    } else if (typeof opt === 'function' && typeof callback === 'undefined') {
      this.defopt.callback = opt;
    } // const self = this;


    wechat.getSignature(this.defopt); // url获取当前页面
    // const url = encodeURIComponent(document.location.href);
    // // 构造传递参数
    // const params = {
    //   sUrl: url,
    // };
    // if (opt.sAppId) {
    //   params.sAppId = opt.sAppId;
    //   self.sAppId = opt.sAppId;
    // } else {
    //   params.sServiceType = this.getServiceType();
    // }
    // if (opt.sAppSecret) {
    //   params.sAppSecret = opt.sAppSecret;
    // }
    // 向后端发起查询请求获取微信签名配置config
    // miloRequest.ajax({
    //   url: this.apiurl,
    //   type: 'get',
    //   data: params,
    //   dataType: 'json',
    //   success(retdata) {
    //     if (retdata.iRet == 0) {
    //       const wxconfig = retdata.jData;
    //       self.config(wxconfig, (wx) => {
    //         callback(wx);
    //       });
    //     } else {
    //       console.log('wxSignErrorMsg:', retdata);
    //     }
    //   },
    // });
  },
  // 请求微信JSAPI库，并使用签名环境初始化
  // config(wxconfig, callback) {
  //   const self = this;
  //   const configWX = function (wx) {
  //     wx.config({
  //       debug: self.defopt.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
  //       appId: wxconfig.appId, // 必填，公众号的唯一标识
  //       timestamp: wxconfig.timestamp, // 必填，生成签名的时间戳
  //       nonceStr: wxconfig.nonceStr, // 必填，生成签名的随机串
  //       signature: wxconfig.signature, // 必填，签名，见附录1
  //       jsApiList: self.defopt.jsApiList, // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
  //     });
  //     wx.ready(() => {
  //       callback(wx);
  //     });
  //     if (self.defopt.debug) {
  //       wx.error((res) => {
  //         alert(res.errMsg);
  //       });
  //     }
  //   };
  //   // console.log(typeof(wx) === 'undefined');
  //   if (typeof(wx) === 'undefined') {
  //     miloRequest.getScript(self.jsliburl).then(() => {
  //       configWX(wx);
  //     });
  //   } else {
  //     configWX(wx);
  //   }
  // },
  shareAll: function shareAll(shareobj) {
    var self = this;

    try {
      ATM.reportATM({
        toappid: 38,
        tomoduletype: 22,
        tointer: 1,
        // 微信分享
        businesstype: getGameId(),
        toreturncode: 0,
        result: 0,
        cgi: location.href,
        errormsg: 'wx share',
        serialtime: parseInt(new Date().getTime() / 1000)
      });
    } catch (error) {
      console.log(error);
    } // 如果老的接口不再支持了，则切换新的分享逻辑：shareNew


    var oldApiList = ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone'];
    wx.checkJsApi({
      jsApiList: oldApiList,
      // 需要检测的JS接口列表，所有JS接口列表见附录2,
      success: function success(res) {
        // 以键值对的形式返回，可用的api值true，不可用为false
        // 如：{'checkResult':{'chooseImage':true},'errMsg':'checkJsApi:ok'}
        var isSupport = true;

        for (var i = 0; i < oldApiList.length; i++) {
          if (!res.checkResult || false == res.checkResult[oldApiList[i]]) {
            isSupport = false;
            break;
          }
        }

        if (isSupport) {
          self.shareOld(shareobj);
        } else {
          self.shareNew(shareobj);
        }
      }
    });
  },
  // 老的分享接口
  shareOld: function shareOld(shareobj) {
    var option = _objectSpread({
      title: 'Milo',
      link: 'https://milo.qq.com/',
      imgUrl: 'https://ossweb-img.qq.com/images/js/miloweb/resource/game_logo.png',
      trigger: function trigger(res) {// alert('用户点击分享到朋友圈');
      },
      success: function success(res) {// alert('已分享');
      },
      cancel: function cancel(res) {// alert('已取消');
      },
      fail: function fail(res) {// alert(JSON.stringify(res));
      }
    }, shareobj); // type:  0:qq  1:qzone  2:app 微信好友  3.timeline 朋友圈


    var initOption = function initOption(oriOption, shareType) {
      var opt = _objectSpread({}, oriOption); // trigger


      opt.trigger = function () {
        isFunction(shareobj.trigger) && shareobj.trigger.apply(null, arguments); // eslint-disable-next-line no-undef

        if (window.EAS && isFunction(EAS.SendClick)) {
          // eslint-disable-next-line no-undef
          EAS.SendClick({
            e_c: "share.wx_".concat(shareType, ".start"),
            c_t: 4
          });
        } // PTT上报不区分是否成功：只上报行为
        // eslint-disable-next-line no-undef


        if (window.PTTSendClick && isFunction(PTTSendClick)) {
          if (3 == shareType) {
            // eslint-disable-next-line no-undef
            PTTSendClick('share', 'timeline_success', '从微信分享至朋友圈成功');
          } else if (2 == shareType) {
            // eslint-disable-next-line no-undef
            PTTSendClick('share', 'message_success', '从微信分享至微信好友成功');
          }
        }
      }; // success


      opt.success = function () {
        isFunction(shareobj.success) && shareobj.success.apply(null, arguments); // eslint-disable-next-line no-undef

        if (window.EAS && isFunction(EAS.SendClick)) {
          // eslint-disable-next-line no-undef
          EAS.SendClick({
            e_c: "share.wx_".concat(shareType, ".end"),
            c_t: 4
          });
        }
      }; // cancel


      opt.cancel = function () {
        isFunction(shareobj.cancel) && shareobj.cancel.apply(null, arguments); // eslint-disable-next-line no-undef

        if (window.EAS && isFunction(EAS.SendClick)) {
          // eslint-disable-next-line no-undef
          EAS.SendClick({
            e_c: "share.wx_".concat(shareType, ".cancel"),
            c_t: 4
          });
        }
      }; // fail


      opt.fail = function () {
        isFunction(shareobj.fail) && shareobj.fail.apply(null, arguments); // eslint-disable-next-line no-undef

        if (window.EAS && isFunction(EAS.SendClick)) {
          // eslint-disable-next-line no-undef
          EAS.SendClick({
            e_c: "share.wx_".concat(shareType, ".fail"),
            c_t: 4
          });
        }
      };

      return opt;
    }; // qq好友


    var option_0 = initOption(option, 0); // qq空间

    var option_1 = initOption(option, 1); // 微信好友

    var option_2 = initOption(option, 2); // 微信朋友圈

    var option_3 = initOption(option, 3); // QQ好友

    wx.onMenuShareQQ(option_0); // QQ空间

    wx.onMenuShareQZone(option_1); // 微信好友

    wx.onMenuShareAppMessage(option_2); // 微信朋友圈

    wx.onMenuShareTimeline(option_3);
    wx.onMenuShareWeibo(option);
  },
  // 新版分享，微信官方文档原文：

  /*
        请注意，原有的 wx.onMenuShareTimeline、wx.onMenuShareAppMessage、wx.onMenuShareQQ、wx.onMenuShareQZone 接口，即将废弃。
        请尽快迁移使用客户端6.7.2及JSSDK 1.4.0以上版本支持的 wx.updateAppMessageShareData、wx.updateTimelineShareData接口。
        https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#3
         不同点:
        1 不支持任何分享按钮触发、成功触发、失败触发的回调
        2.只能支持设置成功的回调
    */
  shareNew: function shareNew(shareobj) {
    var option = _objectSpread({
      title: 'Milo',
      link: 'https://milo.qq.com/',
      imgUrl: 'https://ossweb-img.qq.com/images/js/miloweb/resource/game_logo.png',
      trigger: function trigger(res) {// alert('用户点击分享到朋友圈');
      },
      success: function success(res) {// alert('已分享');
      },
      cancel: function cancel(res) {// alert('已取消');
      },
      fail: function fail(res) {// alert(JSON.stringify(res));
      }
    }, shareobj); // type:  0:qq好友 微信朋友    2:qzone 微信朋友圈


    var initOption = function initOption(oriOption, shareType) {
      var opt = _objectSpread({}, oriOption); // success 设置成功


      opt.success = function () {
        isFunction(shareobj.success) && shareobj.success.apply(null, arguments);

        if (window.EAS && isFunction(EAS.SendClick)) {
          EAS.SendClick({
            e_c: "share.wx_".concat(shareType, ".end"),
            c_t: 4
          });
        }
      };

      return opt;
    }; // qq好友  微信朋友


    var option_0 = initOption(option, 0); // qq空间  微信朋友圈

    var option_2 = initOption(option, 2); // QQ好友  微信朋友

    wx.updateAppMessageShareData(option_0); // QQ空间  微信朋友圈

    wx.updateTimelineShareData(option_2);
    wx.onMenuShareWeibo(option);
  },
  // 获取微信用户的基本信息
  getUserInfo: function getUserInfo(openid, callback) {
    var queryOpenId = ''; // 如果传了openid为string

    if (typeof openid === 'string') {
      queryOpenId = openid;
    } else if (typeof openid === 'function') {
      // 如果只传了回调，就取当前用户的openid
      queryOpenId = cookie.get('openid') ? cookie.get('openid') : '';
      callback = openid;
    }

    var sAppId = this.sAppId;
    var params = {
      openid: queryOpenId,
      sAppId: sAppId,
      sAction: 'getUserInfo'
    }; // 向后端发起查询请求获取用户信息

    miloRequest.ajax({
      url: this.apiurl,
      type: 'get',
      data: params,
      dataType: 'jsonp',
      jsonpCallback: function jsonpCallback(retdata) {
        if (callback) {
          callback(retdata);
        }
      }
    });
  },
  // // 自动获取ServiceType
  // getServiceType() {
  //   // 首先从URL上获取sServiceType
  //   let sServiceType = document.location.host.split('.')[0];
  //   // 如果有定义，就从定义上获取ServiceType
  //   const ams_actdesc = window[`ams_actdesc_${this.defopt.iActivityId}`];
  //   if (ams_actdesc) {
  //     sServiceType =  ams_actdesc.sServiceType;
  //   }
  //   // 如果用户传值，就从用户的传值获取sServiceType
  //   if (this.defopt.sServiceType) {
  //     sServiceType = this.defopt.sServiceType;
  //   }
  //   return sServiceType;
  // },
  // loadJS(file, callback) {
  //   const head = document.getElementsByTagName('head')[0];
  //   const script = document.createElement('script');
  //   script.type = 'text/javascript';
  //   // eslint-disable-next-line no-multi-assign
  //   script.onload = script.onreadystatechange = function () {
  //     console.log(this.readyState);
  //     if (!this.readyState || this.readyState === 'loaded' ||  this.readyState === 'complete') {
  //       script.onload = null;
  //       script.onreadystatechange = null;
  //       callback();
  //     }
  //   };
  //   script.src = file;
  //   head.appendChild(script);
  // },
  getCardConfig: function getCardConfig(callback) {
    var self = this;
    var params = {
      sAction: 'getCardSign',
      sAppId: self.sAppId,
      sCardType: 3
    }; // 向后端发起查询请求获取用户信息

    miloRequest.ajax({
      url: this.apiurl,
      type: 'get',
      data: params,
      dataType: 'jsonp',
      jsonpCallback: function jsonpCallback(retdata) {
        if (callback) {
          callback(retdata);
        }
      }
    });
  },
  getAddCardConfig: function getAddCardConfig(opt, callback) {
    var self = this;
    var params = {
      sAction: 'addCardSign',
      sAppId: self.sAppId,
      sCardId: opt.cardId
    }; // 向后端发起查询请求获取用户信息

    miloRequest.ajax({
      url: this.apiurl,
      type: 'get',
      data: params,
      dataType: 'jsonp',
      jsonpCallback: function jsonpCallback(retdata) {
        if (callback) {
          callback(retdata);
        }
      }
    });
  }
};
export default wxclient;